import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DgError } from '@app/shared/models/dg-error';
import { NgxHttpClient } from '@app/shared/ngx-http-client';

import { TranslateService } from '@ngx-translate/core';

import { UserMonthlyActivity } from '../learner-home-api.model';

@Injectable()
export class MonthlyActivityService {
  constructor(
    private http: NgxHttpClient,
    private translateService: TranslateService
  ) {}

  public getUserMonthlyActivity() {
    return this.http
      .get<UserMonthlyActivity>('/userprofile/GetUserMonthlyActivity')
      .pipe(
        catchError((error) =>
          throwError(
            new DgError(
              this.translateService.instant(
                'DashboardNav_GetMonthlyActivityError'
              ),
              error
            )
          )
        )
      );
  }
}
